import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as BeAPI from "../../../../API";
import PageView from "../../../../Components/PageView";
import { BrandProps } from "../Brands";
import { CategoryProps } from "../Categories";
import { ItemProps } from "../Items";
import { ItemSpecProps } from "../Specs";
import { OutletProps } from "../Outlets";

export interface PriceProps {
  id?: string;
  item: string;
  value: number;
  date: string;
  provePhoto: string;
  outlet: string;
}

const Prices = () => {
  const { t } = useTranslation();

  const [data, setData] = useState<PriceProps[]>([]);
  const [items, setItems] = useState<ItemProps[]>([]);
  const [itemSpecs, setItemSpecs] = useState<ItemSpecProps[]>([]);
  const [brands, setBrands] = useState<BrandProps[]>([]);
  const [categories, setCategories] = useState<CategoryProps[]>([]);
  const [outlets, setOutlets] = useState<OutletProps[]>([]);

  const getData = () => {
    BeAPI.getAll("outlets")
      .then((res: OutletProps[]) => {
        setOutlets(
          res.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1
          )
        );

        BeAPI.getAll("categories")
          .then((res: CategoryProps[]) => {
            const sortedCategories = res.sort((a, b) =>
              a.category.toLowerCase() > b.category.toLowerCase() ? 1 : -1
            );
            setCategories(sortedCategories);

            BeAPI.getAll("items")
              .then((res: ItemProps[]) => {
                const sortedItems = res.sort((a, b) => {
                  const categoryA = sortedCategories.find(
                    ({ id }) => id === String(a.category)
                  );
                  const categoryB = sortedCategories.find(
                    ({ id }) => id === String(b.category)
                  );

                  const categoryAName = categoryA?.category.toLowerCase() || "";
                  const categoryBName = categoryB?.category.toLowerCase() || "";

                  if (categoryAName < categoryBName) return -1;
                  if (categoryAName > categoryBName) return 1;

                  const itemAName = a.name.toLowerCase();
                  const itemBName = b.name.toLowerCase();

                  return itemAName < itemBName
                    ? -1
                    : itemAName > itemBName
                    ? 1
                    : 0;
                });
                setItems(sortedItems);

                BeAPI.getAll("brands")
                  .then((res: BrandProps[]) => {
                    const sortedBrands = res.sort((a, b) =>
                      a.brand.toLowerCase() > b.brand.toLowerCase() ? 1 : -1
                    );
                    setBrands(sortedBrands);

                    BeAPI.getAll("item-specs")
                      .then((res: ItemSpecProps[]) => {
                        const sortedSpecItems = res.sort((a, b) => {
                          const itemA = sortedItems.find(
                            ({ id }) => id === String(a.item)
                          );
                          const itemB = sortedItems.find(
                            ({ id }) => id === String(b.item)
                          );

                          const categoryA = sortedCategories.find(
                            ({ id }) => id === String(itemA?.category)
                          );
                          const categoryB = sortedCategories.find(
                            ({ id }) => id === String(itemB?.category)
                          );

                          const categoryAName =
                            categoryA?.category.toLowerCase() || "";
                          const categoryBName =
                            categoryB?.category.toLowerCase() || "";

                          if (categoryAName < categoryBName) return -1;
                          if (categoryAName > categoryBName) return 1;

                          const itemAName = itemA?.name.toLowerCase() || "";
                          const itemBName = itemB?.name.toLowerCase() || "";

                          if (itemAName < itemBName) return -1;
                          if (itemAName > itemBName) return 1;

                          const brandA = sortedBrands.find(
                            ({ id }) => id === String(a?.brand)
                          );
                          const brandB = sortedBrands.find(
                            ({ id }) => id === String(b?.brand)
                          );

                          const brandAName = brandA?.brand.toLowerCase() || "";
                          const brandBName = brandB?.brand.toLowerCase() || "";

                          return brandAName < brandBName
                            ? -1
                            : brandAName > brandBName
                            ? 1
                            : 0;
                        });
                        setItemSpecs(sortedSpecItems);

                        BeAPI.getAll("prices")
                          .then((res: PriceProps[]) => {
                            const sortedPrices = res.sort((a, b) => {
                              if (a.date > b.date) return -1;
                              if (a.date < b.date) return 1;

                              const itemA = sortedItems.find(
                                ({ id }) => id === String(a.item)
                              );
                              const itemB = sortedItems.find(
                                ({ id }) => id === String(b.item)
                              );

                              const categoryA = sortedCategories.find(
                                ({ id }) => id === String(itemA?.category)
                              );
                              const categoryB = sortedCategories.find(
                                ({ id }) => id === String(itemB?.category)
                              );

                              const categoryAName =
                                categoryA?.category.toLowerCase() || "";
                              const categoryBName =
                                categoryB?.category.toLowerCase() || "";

                              if (categoryAName < categoryBName) return -1;
                              if (categoryAName > categoryBName) return 1;

                              const itemAName = itemA?.name.toLowerCase() || "";
                              const itemBName = itemB?.name.toLowerCase() || "";

                              if (itemAName < itemBName) return -1;
                              if (itemAName > itemBName) return 1;

                              const itemSpecA = sortedSpecItems.find(
                                ({ id }) => id === String(a?.item)
                              );
                              const itemSpecB = sortedSpecItems.find(
                                ({ id }) => id === String(b?.item)
                              );

                              const brandA = sortedBrands.find(
                                ({ id }) => id === String(itemSpecA?.brand)
                              );
                              const brandB = sortedBrands.find(
                                ({ id }) => id === String(itemSpecB?.brand)
                              );

                              const brandAName =
                                brandA?.brand.toLowerCase() || "";
                              const brandBName =
                                brandB?.brand.toLowerCase() || "";

                              return brandAName < brandBName
                                ? -1
                                : brandAName > brandBName
                                ? 1
                                : 0;
                            });
                            setData(sortedPrices);
                          })
                          .catch((err) => console.log({ err }));
                      })
                      .catch((err) => console.log({ err }));
                  })
                  .catch((err) => console.log({ err }));
              })
              .catch((err) => console.log({ err }));
          })
          .catch((err) => console.log({ err }));
      })
      .catch((err) => console.log({ err }));
  };

  useEffect(() => {
    getData();
  }, []);

  const renderItemName = ({ unit, spec, brand, item }: ItemSpecProps) => {
    const brandObj = brands.find(({ id }) => id === brand);
    const itemObj = items.find(({ id }) => id === item);

    return (
      itemObj?.name +
      " " +
      (brandObj?.brand ? "| " + brandObj?.brand + " " : "") +
      "| " +
      unit +
      " واحد(ة)" +
      (spec?.length && spec?.length > 1 ? " | " + spec : "")
    );
  };

  const formInputs = [
    {
      name: "category",
      label: t("Services.Categories.Category"),
      excludeInForm: true,
      render: (row: PriceProps, i: number) => {
        const itemSpec = itemSpecs.find(({ id }) => id === String(row.item));
        const item = items.find(({ id }) => id === String(itemSpec?.item));
        const category = categories.find(
          ({ id }) => id === String(item?.category)
        );

        if (category) {
          return category.category;
        }

        return "-";
      },
    },
    {
      name: "item",
      label: t("Services.Items.Item"),
      type: "select",
      options: itemSpecs?.map(({ id, unit, spec, brand, item }) => {
        return {
          value: id || "",
          label: renderItemName({ unit, spec, brand, item }),
        };
      }),
      render: (row: PriceProps, i: number) => {
        const itemSpec = itemSpecs.find(({ id }) => id === String(row.item));
        const item = items.find(({ id }) => id === String(itemSpec?.item));

        if (item) {
          return item.name;
        }

        return "-";
      },
      required: true,
    },
    {
      name: "specs",
      label: t("Services.ItemSpecs.Spec"),
      excludeInForm: true,
      render: (row: PriceProps, i: number) => {
        const itemSpec = itemSpecs.find(({ id }) => id === String(row.item));

        if (itemSpec) {
          return itemSpec.spec;
        }

        return "-";
      },
    },
    {
      name: "brand",
      label: t("Services.Brands.Brand"),
      excludeInForm: true,
      render: (row: PriceProps, i: number) => {
        const itemSpec = itemSpecs.find(({ id }) => id === String(row.item));
        const brand = brands.find(({ id }) => id === String(itemSpec?.brand));

        if (brand) {
          return brand.brand;
        }

        return "-";
      },
    },
    {
      name: "outlet",
      label: t("Services.Outlets.Outlet"),
      type: "select",
      options: outlets?.map(({ id, name }) => {
        return {
          value: id || "",
          label: name,
        };
      }),
      render: (row: PriceProps, i: number) => {
        const outlet = outlets.find(({ id }) => id === String(row?.outlet));

        if (outlet) {
          return outlet.name;
        }

        return "-";
      },
      required: true,
    },
    {
      name: "value",
      label: t("Services.Prices.Value"),
      type: "number",
      step: 0.01,
      required: true,
    },
    {
      name: "date",
      label: t("Services.Prices.Date"),
      type: "date",
      required: true,
    },
    {
      name: "provePhoto",
      label: t("Services.Prices.ProvePhoto"),
      required: true,
      render: (row: PriceProps) => (
        <a className="text-primary" href={row.provePhoto} target="_blank">
          <FontAwesomeIcon icon={faEye} />
        </a>
      ),
    },
  ];

  const onSubmit = (values: PriceProps) => {
    BeAPI.create("prices", values).then(() => {
      getData();
    });
  };

  const onDelete = (id: string) =>
    BeAPI.remove("prices", id)
      .then(() => {
        getData();
      })
      .catch((err) => console.log({ err }));

  return (
    <PageView
      title={t("Services.Prices.PricesList")}
      data={data}
      inputs={formInputs}
      onSubmit={onSubmit}
      onDelete={onDelete}
    />
  );
};

export default Prices;
